import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Inner, fadeInUp } from '../styles/v2.styled';

const Wrapper = styled.section`
  padding: 72px 0;
  background: ${({ theme }) => theme.colors.neutral[0]};

  @media (max-width: 768px) {
    padding: 48px 0;
  }
`;

const Band = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 28px;
  align-items: center;
  background: #082f36;
  border-radius: 8px;
  padding: 40px 42px;
  animation: ${fadeInUp} 0.6s ease both;

  @media (max-width: 760px) {
    grid-template-columns: 1fr;
    padding: 32px 22px;
  }
`;

const Title = styled.h2`
  font-family: ${({ theme }) => theme.typography.fontFamily.bold};
  font-size: 1.8rem;
  font-weight: 900;
  color: #fff;
  margin: 0 0 10px;
`;

const Desc = styled.p`
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.78);
  line-height: 1.65;
  margin: 0;
`;

const BtnGroup = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;

  @media (max-width: 520px) {
    flex-direction: column;
  }
`;

const Button = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 46px;
  padding: 0 20px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 900;
  white-space: nowrap;
`;

const PrimaryBtn = styled(Button)`
  background: #fff;
  color: #005c68;
`;

const GhostBtn = styled(Button)`
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.36);
`;

function CTASection() {
  return (
    <Wrapper>
      <Inner>
        <Band>
          <div>
            <Title>지금 필요한 기술 교육을 바로 시작하세요</Title>
            <Desc>
              과정 선택이 어렵다면 수강신청 페이지에서 관심 분야와 학습 목표를 남겨 주세요.
              적합한 강의와 학습 순서를 안내해 드립니다.
            </Desc>
          </div>
          <BtnGroup>
            <PrimaryBtn to="/Enroll">수강신청</PrimaryBtn>
            <GhostBtn to="/Courses">과정 둘러보기</GhostBtn>
          </BtnGroup>
        </Band>
      </Inner>
    </Wrapper>
  );
}

export default CTASection;
